export default __webpack_public_path__ + "cb1660cd49a7c1209fa491adac028a45.svg";